var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttendanceClick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f5a161",
    d: "M876.999+915.886C876.999+915.886+271.868+923.473+253.402+922.886C234.935+922.299+222.367+908.685+223.262+891.167L237.853+605.697C237.853+534.055+254.168+463.001+303.102+458.302L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z",
    fill: "#ffe17e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    opacity: 1,
    fill: "#ffe17e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18ea39",
    d: "M676.202+824.093C676.202+750.358+735.976+690.584+809.711+690.584C883.446+690.584+943.22+750.358+943.22+824.093C943.22+897.829+883.446+957.603+809.711+957.603C735.976+957.603+676.202+897.829+676.202+824.093Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.597+823.588C706.597+766.567+752.822+720.342+809.844+720.342C866.866+720.342+913.091+766.567+913.091+823.588C913.091+880.61+866.866+926.836+809.844+926.836C752.822+926.836+706.597+880.61+706.597+823.588Z",
    opacity: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18ea39",
    d: "M792.154+826.708C791.692+827.632+791.229+828.557+790.767+829.481",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.105+820.113L799.26+873.928L857.56+782.443",
    opacity: 1,
    fill: "none",
    strokeLinecap: "round",
    stroke: "#18ea39",
    strokeLinejoin: "round",
    strokeWidth: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.811+82.1394L226.291+88.3024C252.899+92.3533+270.811+122.493+266.301+155.622L266.301+155.622C261.79+188.751+236.564+212.324+209.956+208.273L169.476+202.11C142.869+198.059+124.956+167.919+129.467+134.79L129.467+134.79C133.978+101.661+159.204+78.0885+185.811+82.1394Z",
    opacity: 1,
    fill: "#ffe17e"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M123.976+152.633L258.74+152.883C271.38+152.348+280.242+162.076+278.533+174.612L262.3+295.034C260.591+307.57+264.633+326.435+271.328+337.17C271.328+337.17+339.399+463.971+333.857+475.344C333.857+475.344+245.861+749.835+241.144+738.095L87.9043+368.474C83.188+356.734+80.5082+337.025+81.9189+324.452L98.5343+176.368C99.945+163.795+111.336+153.168+123.976+152.633Z",
    fill: "#f5a160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.828+370.85L585.828+370.85C585.828+403.665+558.638+430.267+525.098+430.267L513.666+430.267C480.126+430.267+452.936+403.665+452.936+370.85L452.936+370.85C471.221+344.287+573.008+351.976+585.828+370.85Z",
    opacity: 1,
    fill: "#e14444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fffaf6",
    d: "M500.667+352.349L512.18+351.975C515.139+351.878+517.589+353.369+517.652+355.305L518.105+369.248C518.168+371.184+515.82+372.831+512.861+372.927L501.348+373.301C498.389+373.397+495.939+371.906+495.876+369.971L495.423+356.027C495.36+354.092+497.708+352.445+500.667+352.349Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M525.27+352.361L536.753+353.264C539.704+353.497+541.974+355.25+541.822+357.18L540.728+371.088C540.576+373.019+538.06+374.395+535.109+374.163L523.626+373.26C520.674+373.028+518.404+371.275+518.556+369.344L519.65+355.436C519.802+353.506+522.318+352.129+525.27+352.361Z",
    fill: "#fffaf6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceClick);
export default __webpack_public_path__ + "static/media/AttendanceClick.c1192a08a8c30986661f70cd8a1556a0.svg";
export { ForwardRef as ReactComponent };